import React, { Component } from 'react';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';
import { showModal, hideModal } from '../../../actions/modal';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import { calculatePriceInfo } from '../../../utils/products.js';
import { showErrorMessageInfo } from '../../../actions/shared/HTTPError';
import deleteFromCartAndAddToWishlist from './deleteFromCartAndAddToWishlist';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import { readCookie } from '../../../components/common/Cookie';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { jioAdsAddtoWishList } from '../../../utils/jioAds';
import { FreebiesProductsItems } from '../../../components/common/Freebies/FreebiesGiftCard';
import { getGiftWithProductConfig, getGiftWithProductEnable } from '../../../refresh/selectors/featureFlagsSelector';
import { deleteProductAttributionToken } from '../../../utils/common'
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const userId = decodeURIComponent(readCookie('U')) || '';
class ProductRemovalPopup extends Component {
  constructor(props) {
    super(props);
    this.textContent = {
      deleteBagText: 'Delete from Bag',
      removeBagText: 'Remove from Cart',
      deleteBagInfo: 'you can save items to your  closet to use this product later',
      deletBtnText: 'DELETE',
      removeBtnText: 'REMOVE',
      closetText: 'MOVE TO WISHLIST',
      removeText: 'MOVE TO WISHLIST'
    };
  }

  handleError(event) {
    event.target.src = `${properties.getProperty('imageBaseUrl')}/static/img/plp.png`;
  }

  removedFromCart = () => {
    const {
      product: {
        baseProduct = '',
        name = '',
        brandName = '',
        brickCategory = '',
        url = '',
        color = '',
        size = '',
        priceInfo = {}
      }
    } = this.props;
    const {
      netPrice: { formattedValue: SP = '' } = {},
      originalPrice: { formattedValue: MRP = '' } = {},
      discount: { formattedValue: Discount = '' } = {}
    } = priceInfo;
    const newUrl = `${properties.getProperty('parentUrl')}${url}`;
    //   const { MRP, Price, Discount } = calculatePriceInfo(priceInfo);
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Removed_From_Cart,
      eventObj: {
        Product_name: name,
        Mrp: MRP,
        sp: SP,
        discount: Discount,
        Page_URL: newUrl,
        Category: brickCategory,
        Brand: brandName,
        Color: color,
        size,
        user_id: userId != 'null' ? userId : 'anonymous',
        platform: 'MSITE',
        source: 'Cart_Page'
      }
    });
  };

  getDataGrinchErrorObject = status => {
    const productDetails = this.props.product;
    const { code, quantity, size, priceInfo = {} } = productDetails;
    const { Price, Discount, CouponSaving } = calculatePriceInfo(priceInfo);

    const eventObj = [];
    eventObj.ProductId = code;
    eventObj.quantity = quantity;
    eventObj.size = size;
    eventObj.status = status;

    eventObj.Price = Price;
    eventObj.Discount = Discount;
    eventObj.CouponSaving = CouponSaving;

    const { pageId, pageType } = getPageInfo(location.pathname || '');
    eventObj.pageId = pageId;
    eventObj.pageType = pageType;

    return eventObj;
  };

  sendDataGrinchForRemoveItem = status => {
    sendEvent('ItemRemoved', this.getDataGrinchErrorObject(status));
  };

  sendAddToWithListDataGlinch = status => {
    sendEvent('MoveToCloset', this.getDataGrinchErrorObject());
  };

  render() {
    const {
      product = {},
      entryNumber = -1,
      code = '',
      modalName = '',
      deleteCard,
      addToCloset,
      showErrorMessageInfo,
      newDesignLuxe,
      position,
      enableGiftWithProductFlag=false,
      isLuxe=false,
      giftWithProductConfig = {}
    } = this.props;

    const { cart: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;

    const {
      images = [],
      altText,
      baseProduct = '',
      brickCategory = '',
      brickSubCategory = '',
      brickName = '',
      priceInfo: { netPrice = {} } = {},
      basePrice = {},
      name,
      giftQuantity=0,
      giftProducts: { quantities =[], gwpType = '' } ={}
    } = product;

    const { gwpCartRemoveProductLevel = '', gwpCartRemoveCartLevel = '' } = giftWithProductConfig;
    let gwpText = '';
    if (gwpType === 'ProductLevelGWP') {
      gwpText = gwpCartRemoveProductLevel;
    } else if (gwpType === 'CartLevelGWP') {
      gwpText = gwpCartRemoveCartLevel;
    }

    const productItems = quantities.map((item, i)=>{
      return {
        brandName: item.productTitle,
        imageUrl: item.image,
        mrp: item.mrp,
        quantity: item.qty,
        isReturnable: item.isReturnable
      }
    });

    const isSignedIn = signInCheck();

    const { deviceType = '' } = this.props;
    let imageRender = images.map((imageData, i) => {
      if (imageData.format == 'cartIcon') {
        return (
          <img
            src={`${replaceWithJioCDN(imageData.url)}`}
            key={i}
            alt=""
          //  title={name}
            onError={this.handleError}
          />
        );
      }
      if (imageData.format == 'PRIMARY') {
        return (
          <img
            src={`${replaceWithJioCDN(imageData.url)}`}
            key={i}
            alt=""
           // title={name}
            onError={this.handleError}
          />
        );
      }
      imageRender = (
        <img
          src={`${properties.getProperty('imageBaseUrl')}/static/img/plp.png`}
          key="broken-img"
          alt=""
        //  title={name}
        />
      );
    });
    return (
      <div className="card-delet">
        <div className="delete-product">
          <div className="deletprod-image">{imageRender}</div>
          <div className="deletprod-info">
            <p role='heading' aria-level={2}>
              {' '}
              {newDesignLuxe ? this.textContent.removeBagText : this.textContent.deleteBagText}
            </p>
            <span>{this.textContent.deleteBagInfo}</span>
          </div>
        </div>
        {enableGiftWithProductFlag && productItems.length> 0 && <div className='freebie-items-delete'>
          <p>{gwpText}</p>
          <FreebiesProductsItems
              products={productItems}
              isDesktop
              isLuxe={isLuxe}
            />
        </div>}
        <span className="card-delete-button-bag">
          <div
            className="closet-btn"
            onClick={() => {
              if (isSignedIn) {
                deleteFromCartAndAddToWishlist(
                  addToCloset,
                  deleteCard,
                  modalName,
                  code,
                  entryNumber,
                  showErrorMessageInfo,
                  'viaProductCardWithPopupModal',
                  position
                );
                newDesignLuxe &&
                  gtmEventPush({
                    event: 'Move_to_closet',
                    event_category: 'bag interactions',
                    event_action: 'Move_to_closet',
                    event_label: readCookie('C'),
                    store_type: luxeStore,
                    page_type: screenType
                  });
                console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
                console.log("TRACK POINT 3 ~ brickName:", brickName)
                jioAdsAddtoWishList({
                  brickCategory: brickCategory || '',
                  brickSubCategory: brickSubCategory || '',
                  brickName: brickName || '',
                  code: baseProduct,
                  price: basePrice?.value,
                  quantity: 1
                });
              } else if (deviceType === 'msite') {
                localStorage.setItem('callInitialGetCart', 'true');
                window.location.href = '/login' + '?referrer=cart';
              } else {
                this.props.showModal('sign-in-up');
                this.props.hideModal(modalName);
              }
            }}
            role="button"
            tabIndex={0}
          >
            {newDesignLuxe ? (
              ''
            ) : (
              <span className="wishlist-bag-popup-icon">
                <img src={`${imageBaseUrl}/static/img/pdp-wishlist-icon-desktop.svg`} aria-hidden={true} alt='Wishlist icon'/>
              </span>
            )}
            {newDesignLuxe ? this.textContent.removeText : this.textContent.closetText}
          </div>
          <div
            className="delete-btn"
            onClick={() => {
              this.removedFromCart();
              deleteCard(modalName, {
                entryNumber,
                code,
                position
              })
                .then(() => { 
                  this.sendDataGrinchForRemoveItem('Success'); 
                  deleteProductAttributionToken(code) 
                })
                .catch(() => this.sendDataGrinchForRemoveItem('Failed'));
            }}
            role="button"
            tabIndex={0}
          >
            {newDesignLuxe ? this.textContent.removeBtnText : this.textContent.deletBtnText}
          </div>
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  giftWithProductConfig: getGiftWithProductConfig(state)
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    showErrorMessageInfo: error => {
      dispatch(showErrorMessageInfo(error));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductRemovalPopup);
